/* FURMORIES — Product Configurator (2026-10-03). One selection state for gallery, price, cart and WhatsApp. Arabic labels 2026-10-30. */
(function(){
  'use strict';
  var NL='\n';
  function $(r,s){ return r.querySelector(s); }
  function $$(r,s){ return Array.prototype.slice.call(r.querySelectorAll(s)); }
  function low(s){ return String(s||'').toLowerCase().trim(); }
  function isColourName(n){ return /colou?r|fabric|upholster|لون|اللون|قماش/i.test(n); }
  function isSizeName(n){ return /size|مقاس|المقاس|حجم/i.test(n); }
  var CM={'twin':'120 × 200 cm','queen':'160 × 200 cm','king':'180 × 200 cm','california king':'200 × 200 cm',
    'توين':'120 × 200 cm','كوين':'160 × 200 cm','كينغ':'180 × 200 cm','كينج':'180 × 200 cm','كاليفورنيا كينغ':'200 × 200 cm','كاليفورنيا كينج':'200 × 200 cm'};
  var SIZE_LABEL={'california king':'California King'};
  function isTwin(v){ var l=low(v); return l==='twin'||l==='توين'||l==='توأم'||l==='مزدوج'; }
  var AR_TR={
    'In stock colours':'الألوان المتوفرة',
    'Order online. Photos show this piece in the selected colour where marked.':'اطلب أونلاين. تُظهر الصور هذه القطعة باللون المختار حيثما يُشار إلى ذلك.',
    'Colour':'اللون','Photo':'صورة','Preview unavailable':'الصورة غير متوفرة',
    'As pictured':'كما في الصورة','Standard':'قياسي',
    'Fabric library — made to order':'مكتبة الأقمشة — حسب الطلب',
    'Quoted on request. We bring the physical sample to you before production.':'السعر عند الطلب. نحضر لك عيّنة حقيقية قبل التصنيع.',
    'Draft preview':'معاينة مبدئية','Request a sample':'اطلب عيّنة',
    'Not offered with the current selection':'غير متوفر مع الاختيار الحالي',
    'Fabric':'القماش','Standard — as pictured':'قياسي — كما في الصورة',
    'Price on request':'السعر عند الطلب','Same size in stock colours: ':'نفس المقاس بالألوان المتوفرة: ',
    'Not available in this combination':'غير متوفر بهذا الاختيار',
    'Quoted on request':'السعر عند الطلب','Unavailable combination':'اختيار غير متوفر',
    'Add to Cart':'أضف إلى السلة','Sold Out':'غير متوفر',
    'Other view · may show a different upholstery':'زاوية أخرى · قد تُظهر قماشًا مختلفًا'
  };
  var AR=false;
  function T(s){ return (AR && AR_TR[s]) ? AR_TR[s] : s; }
  function cmText(s){ return AR ? String(s).replace(' cm',' سم') : s; }

  function init(root){
    if(!root || root.__cfg) return; root.__cfg=1;
    AR=/^ar/i.test(root.getAttribute('data-lang')||document.documentElement.lang||'');
    var D; try{ D=JSON.parse($(root,'[data-cfg-json]').textContent); }catch(e){ return; }
    ['media','colours','library','visuals'].forEach(function(k){ D[k]=(D[k]||[]).filter(Boolean); });
    var form=root.closest('form'), pdp=root.closest('[data-fm-product]')||document;
    var idInput=form?$(form,'[data-fm-varid]'):null;
    var priceEl=$(pdp,'[data-fm-price]'), atc=$(pdp,'[data-fm-atc]');
    var mainFig=$(pdp,'[data-cfg-main]'), thumbsEl=$(pdp,'[data-cfg-thumbs]');
    var quoteOnly=root.getAttribute('data-quote')==='true';
    var hideTwin=root.getAttribute('data-hide-twin')==='true';
    var baseFabric=root.getAttribute('data-base-fabric')||'';

    /* ---------- model ---------- */
    var opts=D.options||[], variants=D.variants||[];
    var single=variants.length===1 && opts.length===1 && low(opts[0].values[0])==='default title';
    var ci=-1; opts.forEach(function(o,i){ if(ci<0 && isColourName(o.name)) ci=i; });
    function hidden(i,val){ return hideTwin && isSizeName(opts[i].name) && isTwin(val); }
    var vis=variants.filter(function(v){ return !v.options.some(function(val,i){ return hidden(i,val); }); });
    if(!vis.length) vis=variants.slice();
    var mediaById={}; D.media.forEach(function(m){ mediaById[m.id]=m; });
    var colourMedia={};
    if(ci>=0) vis.concat(variants).forEach(function(v){ if(v.media && mediaById[v.media] && !colourMedia[v.options[ci]]) colourMedia[v.options[ci]]=v.media; });
    if(ci>=0){
      var vc=opts[ci].values.filter(function(val){ return vis.some(function(v){ return v.options[ci]===val; }); });
      if(vc.length===1 && !colourMedia[vc[0]] && D.media[0]) colourMedia[vc[0]]=D.media[0].id;
    }
    var variantMediaIds={}; variants.forEach(function(v){ if(v.media) variantMediaIds[v.media]=1; });
    var lib=D.library||[], visByFabric={};
    D.visuals.forEach(function(x){
      if(x.mediaId && variantMediaIds[x.mediaId]) return;
      if(!visByFabric[x.fabric]) visByFabric[x.fabric]=x;
    });
    var visualMediaIds={}; D.visuals.forEach(function(x){ if(x.mediaId) visualMediaIds[x.mediaId]=1; });
    var sharedViews=D.media.filter(function(m){ return !variantMediaIds[m.id] && !visualMediaIds[m.id]; });
    var hexBy={}; D.colours.forEach(function(c){ if(c.label) hexBy[low(c.label)]=c; });

    /* ---------- state ---------- */
    var st={sel:[], fabric:null};
    function findVariant(sel){ return vis.filter(function(v){ return v.options.every(function(val,i){ return sel[i]===val; }); })[0]||null; }
    var params=new URLSearchParams(location.search);
    var start=null, qv=params.get('variant');
    if(qv) start=vis.filter(function(v){ return String(v.id)===qv; })[0]||null;
    if(!start && idInput) start=vis.filter(function(v){ return String(v.id)===idInput.value; })[0]||null;
    if(!start) start=vis.filter(function(v){ return v.available; })[0]||vis[0];
    st.sel=start?start.options.slice():[];
    var qf=params.get('fabric'); if(qf && lib.some(function(f){ return f.handle===qf; })) st.fabric=qf;
    var current=start;

    /* ---------- UI scaffolding ---------- */
    var ui=$(root,'[data-cfg-ui]'), fb=$(root,'[data-cfg-fallback]');
    if(fb) fb.hidden=true; ui.hidden=false;
    var fcWrap=$(root,'[data-cfg-fabric-wrap]'), fcBtn=$(root,'[data-cfg-fc]'), panel=$(root,'[data-cfg-panel]'), groupsEl=$(root,'[data-cfg-groups]'), backdrop=$(root,'[data-cfg-backdrop]');
    var optsEl=$(root,'[data-cfg-opts]'), note=$(root,'[data-cfg-note]');
    var hasFabricUI=(ci>=0 && !single) || lib.length>0;
    fcWrap.hidden=!hasFabricUI;

    function swatchStyle(el, colourName, libFab){
      el.style.backgroundImage=''; el.style.backgroundColor='';
      if(libFab){ if(libFab.swatch){ el.style.backgroundImage='url('+libFab.swatch+')'; } else { el.style.backgroundColor=libFab.hex||'#d9cfbf'; el.classList.add('is-flat'); } return; }
      var c=hexBy[low(colourName)];
      if(c && c.img){ el.style.backgroundImage='url('+c.img+')'; return; }
      if(colourMedia[colourName]){ el.style.backgroundImage='url('+mediaById[colourMedia[colourName]].thumb+')'; el.classList.add('is-photo'); return; }
      el.style.backgroundColor=(c&&c.hex)||'#d9cfbf'; el.classList.add('is-flat');
    }
    function mk(tag,cls,txt){ var e=document.createElement(tag); if(cls) e.className=cls; if(txt!=null) e.textContent=txt; return e; }

    function buildGroups(){
      groupsEl.innerHTML='';
      if(ci>=0){
        var g=mk('div','cfg__grp'), h=mk('p','cfg__grp-h',(baseFabric?baseFabric+' — ':'')+T('In stock colours')); g.appendChild(h);
        g.appendChild(mk('p','cfg__grp-s',T('Order online. Photos show this piece in the selected colour where marked.')));
        var grid=mk('div','cfg__grid'); grid.setAttribute('role','radiogroup'); grid.setAttribute('aria-label',T('Colour'));
        opts[ci].values.forEach(function(val){
          if(!vis.some(function(v){ return v.options[ci]===val; })) return;
          var b=mk('button','cfg__opt'); b.type='button'; b.setAttribute('role','radio'); b.setAttribute('data-colour',val);
          var i=mk('i','cfg__sw'); i.setAttribute('aria-hidden','true'); swatchStyle(i,val,null); b.appendChild(i);
          b.appendChild(mk('span','cfg__opt-n',val));
          b.appendChild(mk('span','cfg__opt-s', colourMedia[val]?T('Photo'):T('Preview unavailable')));
          b.addEventListener('click',function(){ st.fabric=null; st.sel[ci]=val; reconcile(ci); closePanel(true); });
          grid.appendChild(b);
        });
        g.appendChild(grid); groupsEl.appendChild(g);
      }
      if(ci<0 && lib.length){
        var g0=mk('div','cfg__grp'); g0.appendChild(mk('p','cfg__grp-h',T('As pictured')));
        var grid0=mk('div','cfg__grid'); grid0.setAttribute('role','radiogroup'); grid0.setAttribute('aria-label',T('As pictured'));
        var b0=mk('button','cfg__opt'); b0.type='button'; b0.setAttribute('role','radio'); b0.setAttribute('data-std','1');
        var i0=mk('i','cfg__sw is-photo'); i0.setAttribute('aria-hidden','true'); if(D.media[0]) i0.style.backgroundImage='url('+D.media[0].thumb+')'; b0.appendChild(i0);
        b0.appendChild(mk('span','cfg__opt-n',T('Standard'))); b0.appendChild(mk('span','cfg__opt-s',T('Photo')));
        b0.addEventListener('click',function(){ st.fabric=null; update(); closePanel(true); });
        grid0.appendChild(b0); g0.appendChild(grid0); groupsEl.appendChild(g0);
      }
      if(lib.length){
        var types=[]; lib.forEach(function(f){ if(types.indexOf(f.type)<0) types.push(f.type); });
        var g2=mk('div','cfg__grp'); g2.appendChild(mk('p','cfg__grp-h',T('Fabric library — made to order')));
        g2.appendChild(mk('p','cfg__grp-s',T('Quoted on request. We bring the physical sample to you before production.')));
        types.forEach(function(ty){
          g2.appendChild(mk('p','cfg__sub',ty));
          var grid=mk('div','cfg__grid'); grid.setAttribute('role','radiogroup'); grid.setAttribute('aria-label',ty);
          lib.filter(function(f){ return f.type===ty; }).forEach(function(f){
            var b=mk('button','cfg__opt'); b.type='button'; b.setAttribute('role','radio'); b.setAttribute('data-fabric',f.handle);
            var i=mk('i','cfg__sw'); i.setAttribute('aria-hidden','true'); swatchStyle(i,null,f); b.appendChild(i);
            b.appendChild(mk('span','cfg__opt-n',f.colour));
            var vx=visByFabric[f.handle];
            b.appendChild(mk('span','cfg__opt-s', vx ? (vx.kind==='draft'?T('Draft preview'):T('Photo')) : T('Request a sample')));
            b.addEventListener('click',function(){ st.fabric=f.handle; update(); closePanel(true); });
            grid.appendChild(b);
          });
          g2.appendChild(grid);
        });
        groupsEl.appendChild(g2);
      }
    }

    function buildOptions(){
      optsEl.innerHTML='';
      opts.forEach(function(o,i){
        if(i===ci || single) return;
        var vals=o.values.filter(function(val){ return !hidden(i,val) && vis.some(function(v){ return v.options[i]===val; }); });
        if(vals.length<1) return;
        var g=mk('div','cfg__group'); g.appendChild(mk('span','cfg__lbl',o.name));
        var row=mk('div','cfg__chips'); row.setAttribute('role','radiogroup'); row.setAttribute('aria-label',o.name);
        vals.forEach(function(val){
          var b=mk('button','cfg__chip'); b.type='button'; b.setAttribute('role','radio'); b.setAttribute('data-i',i); b.setAttribute('data-v',val);
          var lv=low(val);
          b.appendChild(mk('span',null,(!AR&&SIZE_LABEL[lv])||val));
          if(isSizeName(o.name) && CM[lv]) b.appendChild(mk('small',null,cmText(CM[lv])));
          b.addEventListener('click',function(){ st.sel[i]=val; reconcile(i); });
          row.appendChild(b);
        });
        g.appendChild(row); optsEl.appendChild(g);
      });
    }

    var lastMsg='';
    function reconcile(changed){
      var v=findVariant(st.sel);
      lastMsg='';
      if(!v){
        var names=st.sel.filter(function(x){ return x!=null; }).join(' / ');
        lastMsg=AR ? ('هذا الاختيار ('+names+') غير متوفر. يرجى اختيار '+(changed===ci?'خيار':'لون أو خيار')+' آخر، أو اسألنا عبر واتساب.')
          : ('This combination ('+names+') is not offered. Please choose another '+(changed===ci?'option':'colour or option')+', or ask us on WhatsApp.');
      }
      update();
    }

    /* ---------- gallery ---------- */
    var mainImg=mainFig?$(mainFig,'img'):null, badge=null;
    if(mainFig){ badge=mk('div','cfg__badge'); badge.hidden=true; mainFig.appendChild(badge); }
    function setMain(m, badgeTxt, kind){
      if(!mainImg||!m) return;
      if(mainImg.getAttribute('data-src')!==m.src){
        mainImg.setAttribute('data-src',m.src); mainImg.removeAttribute('loading');
        if(m.srcset) mainImg.setAttribute('srcset',m.srcset); else mainImg.removeAttribute('srcset');
        mainImg.src=m.src; mainImg.alt=m.alt||'';
      }
      if(badge){ badge.hidden=!badgeTxt; badge.className='cfg__badge'+(kind?' is-'+kind:''); badge.textContent=badgeTxt||''; }
    }
    function renderGallery(list, activeIdx, labels){
      if(!thumbsEl) return;
      thumbsEl.innerHTML='';
      list.forEach(function(m,k){
        var li=mk('li'), b=mk('button','cfg__th'); b.type='button';
        b.setAttribute('aria-label',(AR?'عرض الصورة ':'View image ')+(k+1)+(labels[k]?' — '+labels[k]:''));
        b.setAttribute('aria-current',k===activeIdx?'true':'false');
        var im=document.createElement('img'); im.src=m.thumb; im.alt=''; im.loading='lazy'; im.width=90; im.height=Math.round(90/(m.ratio||0.8));
        b.appendChild(im);
        b.addEventListener('click',function(){ $$(thumbsEl,'.cfg__th').forEach(function(x){ x.setAttribute('aria-current','false'); }); b.setAttribute('aria-current','true'); setMain(m, labels[k], m.__kind); });
        li.appendChild(b); thumbsEl.appendChild(li);
      });
    }
    function gallery(){
      var first=null, label='', kind='', list=[], labels=[];
      if(st.fabric){
        var f=lib.filter(function(x){ return x.handle===st.fabric; })[0], vx=visByFabric[st.fabric];
        if(vx){ first={src:vx.src,srcset:vx.srcset,thumb:vx.thumb,alt:root.getAttribute('data-title')+' — '+f.colour+' '+f.type,ratio:0.8,__kind:vx.kind==='draft'?'draft':'ok'};
          label=vx.kind==='draft'?(AR?'معاينة مبدئية · '+f.colour+' '+f.type+' · تُؤكَّد بعيّنة':'Draft preview (AI) · '+f.colour+' '+f.type+' · confirm with a sample'):T('Photo')+' · '+f.colour+' '+f.type; kind=first.__kind; }
        else { first=sharedViews[0]||D.media[0]; label=AR?('الصورة غير متوفرة — اطلب عيّنة من '+f.colour+' '+f.type):('Preview unavailable — request a sample of '+f.colour+' '+f.type); kind='pending'; }
      } else if(ci>=0){
        var col=st.sel[ci], mid=colourMedia[col];
        if(mid){ first=mediaById[mid]; first.__kind='ok'; label=T('Photo')+' · '+col; kind='ok'; }
        else { first=sharedViews[0]||D.media[0]; label=AR?('الصورة غير متوفرة — اطلب عيّنة من '+col):('Preview unavailable — request a sample of '+col); kind='pending'; }
      } else { first=D.media[0]; }
      if(first){ list.push(first); labels.push(label); }
      sharedViews.forEach(function(m){ if(m!==first){ m.__kind=''; list.push(m); labels.push((kind==='ok'||kind==='draft'||kind==='pending')?T('Other view · may show a different upholstery'):''); } });
      setMain(first,label,kind);
      renderGallery(list,0,labels);
    }

    /* ---------- render ---------- */
    function libFab(){ return st.fabric?lib.filter(function(x){ return x.handle===st.fabric; })[0]:null; }
    function selText(){
      var parts=[];
      opts.forEach(function(o,i){ if(i===ci||single) return; var val=st.sel[i]; if(val!=null){ var lv=low(val); parts.push(o.name+': '+(SIZE_LABEL[lv]||val)+(isSizeName(o.name)&&CM[lv]?' ('+CM[lv]+')':'')); } });
      return parts;
    }
    function update(){
      var v=findVariant(st.sel), f=libFab();
      current=v;
      if(hasFabricUI){
        var sw=$(root,'[data-cfg-fc-sw]'); sw.className='cfg__sw';
        if(f){ swatchStyle(sw,null,f); $(root,'[data-cfg-fc-fab]').textContent=f.type; $(root,'[data-cfg-fc-col]').textContent=f.colour; }
        else if(ci>=0){ swatchStyle(sw,st.sel[ci],null); $(root,'[data-cfg-fc-fab]').textContent=baseFabric||T('Colour'); $(root,'[data-cfg-fc-col]').textContent=st.sel[ci]; }
        else { sw.classList.add('is-photo'); sw.style.backgroundImage=D.media[0]?'url('+D.media[0].thumb+')':''; $(root,'[data-cfg-fc-fab]').textContent=baseFabric||T('Fabric'); $(root,'[data-cfg-fc-col]').textContent=T('Standard — as pictured'); }
        $$(groupsEl,'.cfg__opt').forEach(function(b){
          var on=f? b.getAttribute('data-fabric')===f.handle : (ci>=0 ? b.getAttribute('data-colour')===st.sel[ci] : b.hasAttribute('data-std'));
          b.setAttribute('aria-checked',on?'true':'false');
        });
      }
      $$(optsEl,'.cfg__chip').forEach(function(b){
        var i=+b.getAttribute('data-i'), val=b.getAttribute('data-v');
        b.setAttribute('aria-checked',st.sel[i]===val?'true':'false');
        var test=st.sel.slice(); test[i]=val;
        var ok=!!findVariant(test);
        b.classList.toggle('is-na',!ok); b.title=ok?'':T('Not offered with the current selection');
      });
      var msg=lastMsg;
      if(f && !msg) msg=AR ? (f.colour+' '+f.type+' يُصنع حسب الطلب والسعر عند الطلب — اضغط «اطلب هذا القماش» وسنؤكّد السعر ونرسل لك عيّنة.')
        : (f.colour+' '+f.type+' is made to order and quoted on request — tap “Request this fabric” and we will confirm price and send a sample.');
      note.hidden=!msg; note.textContent=msg||'';
      if(priceEl && !quoteOnly){
        var sOff=AR?'margin-left:10px':'margin-right:10px';
        if(f){ priceEl.innerHTML='<span class="cfg__q">'+T('Price on request')+'</span>'+(v?'<small class="cfg__from">'+T('Same size in stock colours: ')+v.priceHtml+'</small>':''); }
        else if(v){ priceEl.innerHTML=(v.compareHtml?'<s style="opacity:.5;font-size:.7em;'+sOff+'">'+v.compareHtml+'</s>':'')+v.priceHtml; }
        else { priceEl.innerHTML='<span class="cfg__q">'+T('Not available in this combination')+'</span>'; }
      }
      if(idInput && v) idInput.value=v.id;
      if(atc && !quoteOnly){
        var lbl=$(atc,'.fm-btn__lbl')||atc;
        if(f){ atc.disabled=true; lbl.textContent=T('Quoted on request'); }
        else if(!v){ atc.disabled=true; lbl.textContent=T('Unavailable combination'); }
        else { atc.disabled=!v.available; lbl.textContent=v.available?T('Add to Cart'):T('Sold Out'); }
      }
      gallery();
      whatsapp();
      try{ var u=new URL(location.href); if(v) u.searchParams.set('variant',v.id); if(f) u.searchParams.set('fabric',f.handle); else u.searchParams.delete('fabric'); history.replaceState(history.state,'',u.toString()); }catch(e){}
      root.dispatchEvent(new CustomEvent('fm:config',{bubbles:true,detail:{variant:v,fabric:f}}));
    }

    function whatsapp(){
      var v=current, f=libFab(), title=root.getAttribute('data-title');
      var link=root.getAttribute('data-url')+(v?'?variant='+v.id:'')+(f?(v?'&':'?')+'fabric='+f.handle:'');
      var L=['Hello Furmories,','','I am interested in the '+title+'.',''];
      if(f){ L.push('Fabric & colour: '+f.colour+' '+f.type+' (fabric library'+(f.code?', code '+f.code:'')+')'); }
      else if(ci>=0){ L.push('Fabric & colour: '+(baseFabric?baseFabric+' — ':'')+st.sel[ci]); }
      else if(lib.length){ L.push('Fabric & colour: standard, as pictured'); }
      selText().forEach(function(x){ L.push(x); });
      if(f) L.push('Price: please quote'); else if(v) L.push('Price shown: '+v.priceHtml.replace(/<[^>]+>/g,''));
      else L.push('Note: this combination is not listed — please advise');
      L.push('','Product link:',link,'','My location is: ');
      var txt=L.join(NL);
      $$(pdp,'[data-fm-chat]').forEach(function(a){ a.href='https://wa.me/'+a.getAttribute('data-wa')+'?text='+encodeURIComponent(txt); });
      $$(pdp,'[data-cfg-req]').forEach(function(a){ a.href='https://wa.me/'+root.getAttribute('data-wa')+'?text='+encodeURIComponent(txt); a.hidden=!f; });
      var cs=L.slice(0,-1).concat(['Requested size (W × D × H cm): ','Additional requirements: ']).join(NL);
      $$(pdp,'[data-fm-cs]').forEach(function(a){ a.href='https://wa.me/'+a.getAttribute('data-wa')+'?text='+encodeURIComponent(cs.replace('I am interested in the','I would like a custom size of the')); });
    }

    /* ---------- panel open/close (inline on desktop, bottom drawer on mobile) ---------- */
    var mq=window.matchMedia('(max-width: 759px)');
    function openPanel(){
      panel.hidden=false; fcBtn.setAttribute('aria-expanded','true');
      if(mq.matches){ backdrop.hidden=false; panel.setAttribute('aria-modal','true'); document.documentElement.classList.add('cfg-lock'); }
      var on=$(groupsEl,'[aria-checked="true"]')||$(groupsEl,'.cfg__opt'); if(on) on.focus({preventScroll:!mq.matches});
    }
    function closePanel(focusBtn){
      if(panel.hidden) return;
      panel.hidden=true; backdrop.hidden=true; panel.setAttribute('aria-modal','false'); fcBtn.setAttribute('aria-expanded','false');
      document.documentElement.classList.remove('cfg-lock');
      if(focusBtn) fcBtn.focus({preventScroll:true});
    }
    fcBtn.addEventListener('click',function(){ panel.hidden?openPanel():closePanel(false); });
    $(root,'[data-cfg-close]').addEventListener('click',function(){ closePanel(true); });
    backdrop.addEventListener('click',function(){ closePanel(true); });
    root.addEventListener('keydown',function(e){
      if(e.key==='Escape' && !panel.hidden){ e.preventDefault(); closePanel(true); return; }
      var t=e.target;
      if((t.classList.contains('cfg__opt')||t.classList.contains('cfg__chip')) && /Arrow(Right|Left|Down|Up)/.test(e.key)){
        var sib=$$(t.parentNode,'button'), k=sib.indexOf(t), n=sib.length;
        var nk=/Right|Down/.test(e.key)?(k+1)%n:(k-1+n)%n; e.preventDefault(); sib[nk].focus();
      }
    });
    document.addEventListener('click',function(e){ if(!panel.hidden && !mq.matches && !root.contains(e.target)) closePanel(false); });

    buildGroups(); buildOptions(); update();
  }

  function boot(scope){ $$(scope||document,'[data-cfg]').forEach(init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ boot(); }); else boot();
  document.addEventListener('shopify:section:load',function(e){ boot(e.target); });
  window.FurmoriesConfig={init:init};
})();
